import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { AboutAPI } from '../api/about/aboutapi';
import { AboutRequest } from '../api/about/aboutrequest';
import { AboutResponse } from '../api/about/aboutresponse';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { AboutAPIProcessorImpl } from '../processor/aboutapiprocessor';
import { APIProcessor } from '../processor/apiProcessor';
import { ProcessorFactoryImpl } from './processorfactory';

export class AboutProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(AboutProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getAboutDetails():APIProcessor<AboutRequest, AboutResponse>
    {
        this.logger.log("getAboutDetails() invoked");
        return new AboutAPIProcessorImpl(this.getContext(), new AboutAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/aboutprocessorfactory.tsx